import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100vh;
    @media (max-width: 1024px) {
        padding: ${p => p.length === 1 ? '40px 0 67px' : '0'};
        height: ${p => p.length === 1 ? 'auto' : '100vh'};
    }
    @media (max-width: 929px) {
        justify-content: flex-start;
        align-items: flex-start;
        padding: 40px 0 67px;
        height: auto;
    }
    @media (max-width: 530px) {
        padding: 100px 0;
    }
    @media (max-height: 600px) and (max-width: 530px) {
        padding: 70px 0;
    }
`;

export const Text = styled.div`
    display: block;
    width: 530px;
    opacity: ${p => p.active ? '1' : 0};
    transform: translateY(${p => p.active ? '0' : '60px'});
    transition: 2s;
    @media (max-width: 1599px) {
        width: 469px;
    }
    @media (max-width: 1279px) {
        width: 333px;
    }
    @media (max-width: 997px) {
        width: 320px;
    }
    @media (max-width: 935px) {
        width: calc(100% - 360px);
    }
    @media (max-width: 859px) {
        width: 100%;
        margin-bottom: 0;
        transform: translateY(0);
    }
`;

export const Title = styled.div`
    display: block;
    font-size: ${p => p.sizeMedium ? '22px' : '32px'};
    line-height: 1.33;
    font-family: ${FONTS.regular};
    p {
        margin: 15px 0;
    }
    a {
        font-family: ${FONTS.regular};
        color: ${COLORS.lightBlue};
    }
    @media (max-width: 1279px) {
        font-size: 20px;
        p {
            margin: 8px 0;
        }
    }
`;

export const Note = styled.div`
    display: block;
    font-size: 16px;
    line-height: 1.33;
    font-family: ${FONTS.regular};
    margin-top: ${p => p.bottom ? '30px' : '0'};
    margin-bottom: ${p => p.bottom ? '0' : '20px'};
    @media (max-width: 1279px) {
        font-size: 14px;
        margin-top: ${p => p.bottom ? '20px' : '0'};
        margin-bottom: ${p => p.bottom ? '0' : '10px'};
    }
`;

export const Image = styled.img`
    display: ${p => p.length === 1 ? 'block' : 'none'};
    width: 648px;
    @media (max-width: 1599px) {
        width: 499px;
    }
    @media (max-width: 1279px) {
        width: 374px;
    }
    @media (max-width: 997px) {
        width: 343px;
    }
    @media (max-width: 859px) {
        display: ${p => p.isHorizontal ? 'block' : 'none'};
        width: 100%;
    }
`;
